import React, { useCallback, useEffect, useState } from 'react';
import { zeroPad } from 'react-countdown-now';
import { connect } from 'react-redux';
import api from '../../axios-local-api';
import Box from '../../hoc/Box/Box';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../store/actions/index';
import classes from './QOE.css';
import { Line } from 'react-chartjs-2';
import moment from 'moment';
import Spinner from '../../components/UI/Spinner/Spinner';
import { FaSync, FaInfoCircle } from 'react-icons/fa';
import Tippy from '@tippyjs/react';
import { EquipmentTypes } from '../../shared/common';
import Error from '../../components/UI/Error/Error';
import Modal from '../../components/UI/Modal/Modal';

const QOE = (props) => {
  const [displayQoEInprogress, setdisplayQoEInprogress] = useState(false);
  const [displayQoENoData, setDisplayQoENoData] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [fetchData, setFetchData] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState(
    props.selectedEquipment
  );
  const [devMac, setDevMac] = useState(props.devMac);
  const [startTimer, setStartTimer] = useState('');
  const [counter, setCounter] = useState(
    startTimer ? Math.floor(Date.now() - startTimer) / 1000 : 0
  );
  const [xaxesValues, setXaxesValues] = useState([]);
  const [yaxesValues, setYaxesValues] = useState([]);
  const [stopTimer, setStopTimer] = useState(false);
  const startToGetQoeMetrics = useCallback(() => {
    setdisplayQoEInprogress(true);
    setDisplayQoENoData(false);
    setFetchData(true);
    setDataLoaded(false);
    let payload;
    if (props.selectedEquipment && props.selectedEquipment.type === EquipmentTypes.Pod) {
      payload = { podId: props.selectedEquipment.podId };
    } else {
      payload = { deviceMac: props.devMac };
    }
    setStartTimer(Date.now());
     props.getQoeMetrics(payload);
  //  }, 3000)
  });

  useEffect(() => {
    if(!stopTimer){
      const timer =
        counter >= 0 && setTimeout(() => setCounter(counter + 1), 1000);
      if (counter >= 45 && displayQoEInprogress) {
        setDisplayQoENoData(true);
        setdisplayQoEInprogress(false);
        setCounter(0);
      }
      return () => {
        clearTimeout(timer);
      };
    }
  }, [counter, stopTimer]);

  useEffect(() => {
    if (startTimer && !stopTimer) {
      const millis = Date.now() - startTimer;
      setCounter(Math.floor(millis / 1000));
      if (counter >= 45) {
        setDisplayQoENoData(true);
        setdisplayQoEInprogress(false);
        setCounter(0);
      }
    }
  }, [startTimer, stopTimer]);

  useEffect(() => {
    if (fetchData ) {
      let qoeMetrics = [];
      if (
        props.devMac &&
        props.qoeDevices !== undefined &&
        props.qoeDevices.length
      ) {
        qoeMetrics = props.qoeDevices.filter((deviceInfo) => {
          return deviceInfo.mac === props.devMac;
        });
      } else {
        if (
          props.selectedEquipment !== undefined &&
          props.qoeMetrics !== undefined &&
          props.qoeMetrics.length
        ) {
          qoeMetrics = props.qoeMetrics.filter((nodeInfo) => {
            return nodeInfo.nodeId === props.selectedEquipment.podId;
          });
        }
      }
      if (qoeMetrics.length) {
        setDisplayQoENoData(false);
        if (
          qoeMetrics[0].weightedQoeScore &&
          qoeMetrics[0].weightedQoeScore.length
        ) {
          const formattedMetrics = formatDataSet(
            qoeMetrics[0].weightedQoeScore
          );
          if (
            formattedMetrics &&
            formattedMetrics['labels'] &&
            formattedMetrics['values']
          ) {
            setXaxesValues(formattedMetrics['labels']);
            setYaxesValues(formattedMetrics['values']);
          }
          setdisplayQoEInprogress(false);
          setCounter(0);
          setDataLoaded(true);
        } else {
          setdisplayQoEInprogress(false);
          setDisplayQoENoData(true);
        }
      } else {
        if (!displayQoEInprogress) {
          setDisplayQoENoData(true);
        }
      }
      setStopTimer(true);
      setCounter(0);
      setStartTimer('');
    }
  }, [
    fetchData,
    props.qoeLoaded,
    dataLoaded,
    props.qoeMetrics,
    props.qoeDevices,
  ]);

  useEffect(() => {
    if (
      (props.selectedEquipment &&
        props.selectedEquipment.podId !== selectedEquipment.podId) ||
      (props.devMac !== devMac)
    ) {
      setdisplayQoEInprogress(false);
      setCounter(0);
      setDisplayQoENoData(false);
      setXaxesValues([]);
      setYaxesValues([]);
      setSelectedEquipment(props.selectedEquipment);
      setDevMac(props.devMac);
      setDataLoaded(false);
      setFetchData(false);
    }
  }, [props.selectedEquipment, props.devMac, devMac]);

  const spinner = (
    <div id='QoEGetScoreMsg' style={{ padding: '20px', textAlign: 'center' }}>
      <div style={{ margin: '25px auto !important' }}>
        <Spinner fontSize={5} margin='25px auto'>
          {' '}
        </Spinner>
      </div>
      {
        'Gathering Qoe score may take up to 45 seconds to complete and cannot be cancelled.'
      }
      <br />
      {`00:${zeroPad(counter)}`}
    </div>
  );

  let qoeFinalResult = {
    'score' : '',
    'datetime' : '',
    'color' : '',
    'status': ''
  };
  const getLatestDateRecord = (records, displayDates) => {
    if (records === null) return [];
    let recordsByDate = [];
    records.forEach((record) => {
      record.timestamp = moment(record.timestamp).format('MM-DD hh:mm a');
      record.value = record.value ? record.value : 0;
      recordsByDate.push(record);
    });
    displayDates.forEach(function(o1){
        // filter out (!) items in result2
        return recordsByDate.forEach(function(o2){
          if(o1.timestamp === o2.timestamp){
            o1.value = o2.value;
          }
        });

    })
    return displayDates;
  };

  const formatDataSet = (data) => {
    let displayDates;
    let interval15min = [];
    for (var i = 0; i <= 7; i++) {
      let dateWithStartTime = moment(Date.now())
        .subtract(i, 'days')
        .format('MM-DD hh:mm a');
      let dateTime = dateWithStartTime.split(' ');
      let date = dateTime[0];
      let time = dateTime[1].split(':');
      let startHour = time[0];
      if(dateTime[2] === 'pm' && startHour != 12){
        startHour = parseInt(startHour) + 12;
      }
      let roundoffTime = (Math.round(time[1] / 15) * 15) % 60;
      if (roundoffTime > time[1]) {
        roundoffTime = roundoffTime - 15;
      }
      if (time[1] >= '45') {
        roundoffTime = '45';
      }
     
      let startMinute = roundoffTime / 15;

      if (i === 7) {
        for (let h = 23; h >= startHour; h--) {
            startMinute = 3;
          for (let m = startMinute; m >= 0; m--) {
            let min = m === 0 ? 0 : m * 15;
            interval15min.push({
              value: 'N/A',
              timestamp:
               date + ' ' + moment({ h, minute: min }).format('hh:mm a'),
            });
          }          
        } 
      }else if(i === 0){
        if(startHour === '12' && dateTime[2] === 'am'){
          startHour = 0;
        }
        for(let h = startHour; h >= 0; h--){
          if(h ===  startHour){
            startMinute = roundoffTime/15;
          }else{
            startMinute = 3;
          }
          for(let m = startMinute; m >= 0; m--){
            let min = (m === 0) ? 0 : (m * 15);
            interval15min.push({
              value: 'N/A',
              timestamp: date + ' ' + moment({h,minute:min}).format('hh:mm a'),
            });
          }          
        } 
      }else{
        for(let h = 23; h >= 0 ; h--){
          for(let m = 3; m >= 0; m--){
            let min = (m === 0) ? 0 : (m * 15);
            interval15min.push({
              value: 'N/A',
              timestamp: date + ' ' + moment({h,minute:min}).format('hh:mm a'),
            });
          }          
        } 
      }
    }
    displayDates = interval15min;    
    let sortedDisplayDates = displayDates.sort((a,b) => {
      return b.timestamp - a.timestamp;
    });
    
    let sortedData = data.sort((a,b) => {
      return b.timestamp - a.timestamp;
    });
   
    let qoeScores = getLatestDateRecord(sortedData, sortedDisplayDates);
    // Removing the latest record as per WIN-233
    // qoeScores.splice(0, 1);
    let formattedDataSet = {
      labels: [],
      values: [],
    };
    qoeScores.forEach((v) => {
        if (
          !formattedDataSet['labels'].includes(
            v.timestamp
          )
        ) {
          let val = v.value
            ? (v.value === 'N/A' ? v.value : v.value.toFixed(2))
            : 0;
          formattedDataSet['labels'].push(v.timestamp);
          formattedDataSet['values'].push(val);
        }
    });
    return formattedDataSet;
  };
  let item = 0;
  if(yaxesValues[0] > 0){
    qoeFinalResult['score'] = yaxesValues[0];
  } else {
    yaxesValues.forEach((v, k) => {
      if(v > 0 && qoeFinalResult['score'] === ''){
        item = k;
        qoeFinalResult['score'] = v;
        return;
      }
    })
  }
  
  let lastKnownDate = '';
  if(xaxesValues[item]){
    lastKnownDate = xaxesValues[item].split(' ');
    qoeFinalResult['datetime'] = lastKnownDate[1] + ' ' +lastKnownDate[2] + ' ' + lastKnownDate[0].replace('-','/') ;
    
  }
  qoeFinalResult['color'] = qoeFinalResult['score'] >=3 ? 'green': 'red';
  qoeFinalResult['status'] = qoeFinalResult['score'] >=3 ? 'Pass': 'Fail';

  const labels = xaxesValues;

  const options = {
    legend: {
      display: false,
    },
    plugins: {
      responsive: true,
      maintainAspectRatio: false,
      tooltip: {
        enabled: window.innerWidth > 900,
      },
    },
    scales: {
      xAxes: [
        {
          gridLines: {
            display: false,
          },
          ticks: {
            maxTicksLimit: 1000,
            stepSize: 1,
            source: 'data'
          },
        },
      ],
      grid: {
        borderWidth: 0,
      },
      
    },
  };
  const startdate = new Date(Date.now());
  const enddate = new Date(Date.now() - (7 * 86400000 + 1200000));
  const data = {
    type: 'line',
    labels: labels.map((x) => x),
    datasets: [
      {
        label: 'Calculating',
        borderWidth: 0,
        fill: false,
        backgroundColor: 'orange',
        borderColor: 'orange',
        borderDash: [0, 5],
        pointRadius: 5,
        data: yaxesValues.map((item) => {
          if (item === 0) {
            return {
              y: item,
              x: moment(enddate).utcOffset(new Date().getTimezoneOffset()),
            };
          }
        }),
      },
      {
        label: 'No Data',
        borderWidth: 0,
        fill: false,
        backgroundColor: 'grey',
        borderColor: 'grey',
        borderDash: [0, 5],
        pointRadius: 5,
        data: yaxesValues.map((item) => {
          if (item === 'N/A') {
            return {
              y: 0,
              x: moment(enddate).utcOffset(new Date().getTimezoneOffset()),
            };
          }
        }),
      },
      {
        label: 'Fail',
        borderWidth: 0,
        fill: false,
        backgroundColor: 'red',
        borderColor: 'red',
        borderDash: [0, 5],
        pointRadius: 5,
        data: yaxesValues.map((item) => {
          if (item >= 1 && item < 3) {
            return {
              y: item,
              x: moment(enddate).utcOffset(new Date().getTimezoneOffset()),
            };
          }
        }),
      },
      {
        label: 'Pass',
        borderWidth: 0,
        fill: false,
        borderColor: 'green',
        backgroundColor: 'green',
        borderDash: [0, 5],
        pointRadius: 5,
        pointHitRadius: 10,
        data: yaxesValues.map((item) => {
          if (item >= 3) {
            return {
              y: item,
              x: moment(enddate).utcOffset(new Date().getTimezoneOffset()),
            };
          }
        }),
      },
          
    ],
  };
  const chartWidth = yaxesValues.length < 50 ? '1200px' : '12500px';
  let disablemsg = '';
  if (props.freq === 'Ethernet' || props.freq === 'ethernet') {
    if (props.devMac)
      disablemsg = 'QoE is not available for ethernet-connected devices';
    else disablemsg = 'QoE is not available for ethernet-connected Extenders';
  }

  const displayTooltip = () => {
    return displayTooltip ? false : true;
  }
  return (
    <Box>
      <Modal
        show={props.error}
        modalClosed={() => {
          getQoeFailedReset();
        }}
      >
        <Error id={'QOE error'} />
      </Modal>
      <div className={classes.QOE}>
        <div className={classes.TitleArea}>
          <div className={classes.TitleLeft}>
            <h3 style={{ paddingRight: 20 }}>
              Historical {props.devMac ? 'Device' : 'Extender'} QoE
            </h3>
          </div>
          {dataLoaded && (
              <div className={classes.DataRefresh}>
                <div >
                  {moment(Date.now()).subtract(7, 'days').format('MM/DD/YYYY') +
                    ' - ' +
                    moment(Date.now()).format('MM/DD/YYYY')}
                </div>
                
              </div>
            )
          }
          <div className={classes.DataRefresh}>
            {dataLoaded ? (
               <button
               id="QOERefresh"
               className={classes.RegularButton}
               onClick={startToGetQoeMetrics}
             >
               <FaSync /> Refresh
             </button>
            ) : displayQoEInprogress ? (
              <button id='QOEInprogress' className={classes.InprogressButton}>
                In Progress
              </button>
            ) : (
              <button
                id='QoEGetScore'
                className={classes.RegularButton}
                onClick={startToGetQoeMetrics}
                disabled={
                  props.freq === 'Ethernet' ||
                    props.freq === 'ethernet'
                    ? true
                    : false
                }
                title={disablemsg}
              >
                Get Score
              </button>
            )}
          </div>
        </div>
        {!displayQoEInprogress &&
          props.qoeLoaded &&
          !displayQoENoData &&
          xaxesValues.length > 0 &&
          yaxesValues.length > 0 && (
        <div className={classes.QoeInfo}>
          <div className={classes.QoeResult}>
            <div style={{display:'inline-flex', fontSize:'2em', fontWeight: 'bold'}}>
              <span style={{color:qoeFinalResult['color']}}>{qoeFinalResult['status']}</span>
            </div>
            <span style={{backgroundColor: 'lightgray', color: 'gray'}}> Last Known : {qoeFinalResult['datetime']}</span>
          </div>
          <div className={classes.QoeChartLegends}>
          
          <Tippy
                placement='left'
                offset={[0, 2]}
                  content={
                    <div
                      style={{
                        padding: '7px',
                        display: 'inline-flex',
                        flexDirection: 'column',
                        width: '100%',
                        borderRadius: 5,
                        border: '1px lightgray solid',
                        boxSizing: 'border-box',
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div
                          className={classes.QoeChartColor}
                          style={{ backgroundColor: 'green' }}
                        ></div>
                        <div style={{ width: '10px' }} />
                        Pass
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div
                          className={classes.QoeChartColor}
                          style={{ backgroundColor: 'red' }}
                        ></div>
                        <div style={{ width: '10px' }} />
                        Fail
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div
                          className={classes.QoeChartColor}
                          style={{ backgroundColor: 'orange' }}
                        ></div>
                        <div style={{ width: '10px' }} />
                        Calculating
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div
                          className={classes.QoeChartColor}
                          style={{ backgroundColor: 'gray' }}
                        ></div>
                        <div style={{ width: '10px' }} />
                        No Data
                      </div>
                    </div>
                  }
                >
                  <span>
                    <FaInfoCircle color={'lightgray'} size={30} />
                  </span>
                </Tippy>
              </div>
            </div>
          )}
        {!props.devMac && <div className={classes.Separator} />}
        {displayQoEInprogress && !displayQoENoData && spinner}
        {displayQoENoData && !displayQoEInprogress && (
          <div id='QOENoDataAvailable' className={classes.qoeResultsMsg}>
            No data available.
          </div>
        )}
        {!displayQoEInprogress &&
          props.qoeLoaded &&
          !displayQoENoData &&
          xaxesValues.length > 0 &&
          yaxesValues.length > 0 && (
            <div style={{ overflowX: 'auto', overflowY: 'hidden' }}>
              <div style={{ width: chartWidth, height: '450px' }}>
                {/* <div className={classes.chartAreaWrapper}> */}
                <Line id = 'GraphQoe' options={options} data={data} width='0' height='450' />
                {/* </div>  */}
              </div>
            </div>
          )}
      </div>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  success: state.qoe.qoeSuccess,
  error: state.qoe.qoeFailed,
  qoeMetrics: state.qoe.qoe.nodes,
  qoeLoaded: state.qoe.qoeLoaded,
  qoeDevices: state.qoe.qoe.devices,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getQoeMetrics: (payload) =>
      dispatch(actions.getHistoricalQoeMetrics(payload)),
    getQoeFailedReset: () => dispatch(actions.getHistoricalQoeMetrics(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(QOE, api));
